var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.38653 2.97656H1.67649C1.10549 2.97656 0.638306 3.44375 0.638306 4.01475V10.763C0.638306 11.0485 0.871898 11.2821 1.1574 11.2821C1.4429 11.2821 1.67649 11.0485 1.67649 10.763V4.53385C1.67649 4.24834 1.91009 4.01475 2.19559 4.01475H7.38653C7.67203 4.01475 7.90563 3.78116 7.90563 3.49566C7.90563 3.21015 7.67203 2.97656 7.38653 2.97656ZM7.6928 5.35921L10.2 7.86643C10.3921 8.0585 10.5011 8.32324 10.5011 8.59835V13.3585C10.5011 13.9295 10.0339 14.3966 9.46291 14.3966H3.74768C3.17668 14.3966 2.71468 13.9295 2.71468 13.3585L2.71987 6.09113C2.71987 5.52013 3.18187 5.05294 3.75287 5.05294H6.95568C7.2308 5.05294 7.49554 5.16195 7.6928 5.35921ZM7.38653 8.6866H9.72246L6.86744 5.83158V8.16751C6.86744 8.45301 7.10103 8.6866 7.38653 8.6866Z",
    fill: "#EF2E25"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.864481254919c313c8cafc47504fa5db.svg";
export { ForwardRef as ReactComponent };